import { css } from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var iconButtonBase = css(["flex-shrink:0;", ""], function (_ref) {
  var $round = _ref.$round;
  return $round && "\n    border-radius: " + themeGet('borderRadius.circle') + ";\n  ";
});
var defaultPrimaryAppearance = css(["color:", ";border-color:", ";background-color:", ";[data-icon='falcon']{color:", ";}&:disabled{opacity:0.5;}&:not(:disabled){&:hover{[data-icon='falcon']{color:", ";}color:", ";border-color:", ";background-color:", ";}&:active{background-color:", ";}&:focus-visible{box-shadow:0 0 0 ", " ", ";}}"], themeGet('colors.text.200'), themeGet('colors.border.200'), themeGet('colors.primary.0'), themeGet('colors.primary.600'), themeGet('colors.primary.1000'), themeGet('colors.primary.1000'), themeGet('colors.primary.1000'), themeGet('colors.primary.100'), themeGet('colors.primary.100'), pxToRem(4), themeGet('colors.focus.primary'));
var toggledPrimaryAppearance = css(["color:", ";border-color:", ";background-color:", ";[data-icon='falcon']{color:", ";}&:disabled{opacity:0.5;}&:not(:disabled){&:hover{background-color:", ";}&:active{background-color:", ";}&:focus-visible{box-shadow:0 0 0 ", " ", ";}}"], themeGet('colors.primary.1000'), themeGet('colors.primary.1000'), themeGet('colors.primary.50'), themeGet('colors.primary.1000'), themeGet('colors.primary.0'), themeGet('colors.primary.100'), pxToRem(4), themeGet('colors.focus.primary'));
var getToggleButtonAppearance = function getToggleButtonAppearance(appearance, toggled) {
  if (toggled) {
    switch (appearance) {
      case 'primary':
      default:
        return toggledPrimaryAppearance;
    }
  }
  switch (appearance) {
    case 'primary':
    default:
      return defaultPrimaryAppearance;
  }
};

export { getToggleButtonAppearance, iconButtonBase };
